import React from 'react';
import * as styles from './PageFade.module.css';

/**
 * Wraps every routed page. Re-keying the inner element on pathname remounts it
 * on each client-side navigation, which replays the fade-in animation so route
 * changes feel like a smooth crossfade instead of an abrupt, fragmented swap.
 *
 * The page (including its fixed/sticky <Header/>) fades in as one cohesive
 * unit, which masks the header re-mount. Opacity-only — no transform/filter —
 * so it never establishes a containing block for position:fixed descendants.
 */
const PageFade = ({ children, location }) => (
  <div
    key={location ? location.pathname : undefined}
    className={styles.pageFade}
  >
    {children}
  </div>
);

export default PageFade;
